export const useShouldReloadAppOnPageLeave = () => useState('shouldReloadAppOnPageLeave', () => false)
